import * as React from "react";
import { useFormikContext } from "formik";

import { InputField, SelectCountryField, SelectField } from "affinityForm/fields";
import { Grid } from "affinityUI/elements/grid";
import { DataEntryGroup } from "affinityUI/form/components";
import { US_STATES } from "lib/constants/usStates";

import type { PatientFormData } from "../../types";

const DEFAULT_COLS = { xs: [1], lg: [1, 1] };

export const SectionAddress: React.FC = () => {
  const { values } = useFormikContext<PatientFormData>();
  const isUS = values?.contactDetails?.address?.countryCode === "US";

  return (
    <DataEntryGroup title="Address" id="address">
      <SelectCountryField name="contactDetails.address.countryCode">Country</SelectCountryField>
      <InputField name="contactDetails.address.line1">Address Line 1</InputField>
      <InputField name="contactDetails.address.line2">
        Address Line 2 <span>(optional)</span>
      </InputField>
      <Grid $cols={DEFAULT_COLS}>
        <InputField name="contactDetails.address.city">City</InputField>
        {isUS && (
          <SelectField name="contactDetails.address.state" options={US_STATES}>
            State
          </SelectField>
        )}
        <InputField name="contactDetails.address.postcode">Zip Code</InputField>
      </Grid>
    </DataEntryGroup>
  );
};
